import { useAppSelector } from "../ReduxToolkit/Hooks";
import { RootState } from "../ReduxToolkit/Store";

type SelectorFn = (state: RootState) => boolean;

export const useIsLoading = (selectors: SelectorFn[]): boolean => {
  return useAppSelector((state) =>
    selectors.some((selector) => selector(state))
  );
};
